export const en = {
  msg:
    { // HomePage
      'registered_employees_text': 'Registered Participants',
      'finished_employees_text': 'Test Reports',
      // Results Page
      'sessionDropdownLabel': 'Session',
      'results_page_heading_name': 'Results',
      'filters': 'Filters',
      'table_heading': 'List of Individual Test Report',
      'search': 'Search',
      'close_label': 'Close',
      // Table Headers (Results Page)
      'table_header_no': 'No',
      'table_header_name': 'Name',
      'table_header_employeeId': 'Identification Number (ID)',
      'table_header_assessment_name': 'Assessment Name',
      'table_header_assessment_session': 'Assessment Date',
      'table_header_report': 'Report',
      'table_header_status': 'Status',
      'search_placeholder': 'Search',
      // Header
      'logout': 'Logout',
      // SideBar
      'sidebar_text_dashboard': 'Dashboard',
      'sidebar_text_results': 'Results',
      // TimeOut Dialog
      'session_expire_heading': 'Session Expiring Warning',
      'session_expire_message_1': 'Your session will expire in',
      'session_expire_message_2': 'seconds',
      // Report Unavailable
      'report_unavailable': 'Please wait while the report is being generated.<br>If the problem persists please contact support',
      // Loader
      'loading': 'Loading',
        'login': 'Login',
        'username_error_required': 'Please enter your username.',
        'password_error_required': 'Please enter your password.',
        'error': 'Invalid username or password',
        'blank_username_field': 'Please enter your username.',
        'blank_password_field': 'Please enter your password.',
        'invalid_credentials': 'Please enter a valid username or password.',
        'copyright': 'Powered by Global Psytech',
        'username_label': 'Username',
        'password_label': 'Password',
        'serverError': 'Sorry, something went wrong. Please try again.',
        'footer_text': 'Global Psytech Sdn. Bhd.',
        'login_button': 'Login'
    }
}
